import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const listCustomReservedInventoryBucketTypes = {
  name: "listCustomReservedInventoryBucketTypes" as const,
  input: z.object({}),
  output: z.object({
    types: z.array(
      z.object({
        id: customReservedInventoryBucketTypeIdFormat.schema,
        name: z.string(),
        createdAt: z.string(),
      }),
    ),
  }),
};
